// extracted by mini-css-extract-plugin
module.exports = {"aside":"_2mURn","section":"p7TGq","height880":"_37mNI"};